import Option, { OptionProps } from './option';

export type { OptionProps };
export default Option;
